var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "22", height: "19", viewBox: "0 0 22 19", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M19.5 14a2.5 2.5 0 0 1 2.5 2.5V18a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-1.5A2.5 2.5 0 0 1 2.5 14h17zm0 1.5h-17a1 1 0 0 0-.993.883L1.5 16.5v1h19v-1a1 1 0 0 0-.883-.993L19.5 15.5zM13 .25a.75.75 0 0 1 .102 1.493L13 1.75h-1.25v1.541c4.142.451 8 4.545 8 8.709a.75.75 0 0 1-.648.743L19 12.75H3a.75.75 0 0 1-.75-.75c0-4.826 3.575-8.36 8-8.72V1.75H9A.75.75 0 0 1 8.898.257L9 .25h4zm-2 4.5c-3.563 0-6.58 2.435-7.152 6.007l-.036.25-.028.243h14.412l-.014-.11c-.495-3.142-3.59-6.114-6.742-6.372l-.225-.014L11 4.75z", fill: "#292D32" })
  );
});